<template>
  <el-row class="articleContent" ref="print" id="print">
    <el-col :span="24">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="margin-top-10"
      >
        <el-breadcrumb-item
          ><span style="cursor: pointer" @click="jump">{{
            articleInfo.extendFeild3
          }}</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ articleInfo.articleTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="printButton">
        <el-button class="themeButton" icon="el-icon-printer" @click="pri"
          >打印本页</el-button
        >
      </div>
      <div class="printContent">
        <p class="readCountLabel">
          浏览次数：<span class="readCount">{{ articleInfo.visits }}</span>
        </p>
        <p :style="'color:' + titleColor" class="contentHeader">
          {{ articleInfo.articleTitle }}
        </p>
        <div class="content" v-html="articleInfo.content"></div>
      </div>
      <div class="printButton">
        <el-button class="themeButton" icon="el-icon-printer" @click="pri"
          >打印本页</el-button
        >
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { URL_ARTICLE_INFO } from "../../utils/api";
import util from "../../utils/util";
export default {
  name: "ArticleContent",
  data() {
    return {
      titleColor: "",
      articleInfo: {
        articleId: "",
        articleTitle: "",
        content: "",
        channelId: "",
        extendFeild3: "", //栏目名称
        visits: 0,
      },
    };
  },
  methods: {
    pri() {
      this.$print(this.$refs.print);
    },
    jump() {
      console.log(this.articleInfo.extendFeild3);
      if (this.articleInfo.extendFeild3 === "通知" || this.articleInfo.extendFeild3 === "公示") {
        this.$router.push("/article/list");
      } else if (this.articleInfo.extendFeild3 === "国务院文件") {
        this.$router.push("/article/listLeft");
      }
    },
    getArticleInfoById() {
      let Url = util.getAjaxUrl("axiosThree");
      this.$http
        .get(Url + URL_ARTICLE_INFO + this.articleInfo.articleId, "")
        .then((resp) => {
          if (resp.data.success) {
            this.titleColor = resp.data.data.titleColor;
            Object.keys(this.articleInfo).forEach((item) => {
              this.articleInfo[item] = resp.data.data[item];
            });
            this.articleInfo.visits = resp.data.data.visits;
          } else {
            this.$alert("获取文章详情失败");
          }
        });
    },
  },
  mounted() {
    this.articleInfo.articleId = this.$route.query.articleId;
    this.getArticleInfoById();
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
.articleContent {
  width: 96%;
  margin: 0 auto;
  padding-top: 10px;
  .printButton {
    width: 100%;
    display: flow-root;
    margin: 20px 0;
  }
  .themeButton {
    background-color: @theme-color;
    border-color: @theme-color;
    color: #ffffff;
    padding: 9px 15px;
    float: right;
    font-size: 12px;
  }
  .themeButton:hover {
    background-color: #c54949;
  }
  .readCountLabel {
    text-align: right;
    padding-right: 10px;
    margin: 10px 0 15px;
    font-size: 16px;
  }
  .readCount {
    color: #ec1d1d;
    font-weight: 700;
  }
  .contentHeader {
    // color: #ec1d1d;
    border-bottom: 1px solid #ec1d1d;
    font-size: 22px;
    text-align: center;
    line-height: 38px;
    font-weight: 700;
  }
  .content {
    margin: 20px 0;
    padding: 0 10px 20px;
    text-indent: 43px;
    line-height: 1.3;
    font-family: Microsoft YaHei !important;
    border-bottom: 1px solid #303133;
    font-size: 17px !important;
    min-height: 20rem;
  }
}
</style>
